<template>
  <div class="users">
    <h1>Brugere</h1>
    <div class="d-flex mb-3 mt-4">
      <b-form-group
        label="Brugertyper"
        label-for="user-types"
        class="w-50 mr-4"
        label-class="hidden-text"
      >
        <b-form-select id="user-types" :options="[{ text: 'Alle brugere', value: null }].concat(roleOptions)" v-model="selectedRole"></b-form-select>
      </b-form-group>
      <b-form-group
        label="Filtrering"
        label-for="user-filter"
        class="w-50"
        label-class="hidden-text"
      >
        <b-input id="user-filter" v-model="filter" placeholder="Filtrer brugere"></b-input>
      </b-form-group>
    </div>
    <b-table striped hover :items="computedUsers" :fields="fields" :filter="filter" class="no-details">
      <template #cell(roles)="row">
        <template v-if="row.detailsShowing">
          <b-form-checkbox-group
            v-model="row.item.roles"
            :options="roleOptions"
            @change="saveUsers()"
          ></b-form-checkbox-group>
        </template>
        <template v-else>
          <template v-if="row.item.roles.length">
            <span
              v-for="(value, index) of row.item.roles"
              :key="'role-' + index"
            ><template v-if="index > 0">, </template>{{roles[value]}}</span>
          </template>
          <template v-else>
            <em>Ingen</em>
          </template>
        </template>
      </template>
      <template #cell(actions)="row">
        <b-button size="sm" @click="row.toggleDetails" variant="primary">
          <b-icon :icon="row.detailsShowing ? 'check' : 'pencil'"></b-icon>
          <span class="hidden-text">Redigér bruger</span>
        </b-button>
      </template>
      <template #row-details=""></template>
    </b-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    selectedRole: null,
    filter: '',
    users: [
      {
        fullName: 'Niels Nielsen',
        email: 'nn@example.com',
        roles: ['admin', 'editor']
      },
      {
        fullName: 'Jens Jensen',
        email: 'jj@example.com',
        roles: ['editor']
      },
      {
        fullName: 'Lars Larsen',
        email: 'll@example.com',
        roles: ['admin']
      }
    ],
    fields: [
      {
        key: 'fullName',
        label: 'Fulde Navn',
        sortable: true
      },
      {
        key: 'email',
        label: 'E-mailadresse',
        sortable: true
      },
      {
        key: 'roles',
        label: 'Roller',
      },
      { 
        key: 'actions',
        label: 'Redigér',
        thStyle: 'opacity: 0;'
      }
    ],
    roles: {
      admin: 'Administrator',
      editor: 'Redaktør'
    }
  }),
  computed: {
    roleOptions() {
      let options = []
      for (let role of Object.keys(this.roles)) {
        options.push({
          text: this.roles[role],
          value: role
        })
      }
      return options
    },
    computedUsers() {
      if (this.selectedRole) {
        return this.users.filter(user => user.roles.includes(this.selectedRole))
      }
      return this.users
    }
  },
  methods: {
    saveUsers() {
      console.log('saving')
    }
  }
}
</script>

<style>
  .no-details .b-table-details td {
    display: none;
  }
</style>